import React from "react";
import { Builder, BuilderBlocks } from "@builder.io/react";
import { SocialProofType } from "@components/RedesignComponents/types/SocialProof";
import useOnClick from "@hooks/useOnClicks";
import SocialProof from "@components/RedesignComponents/SocialProofModule";

const SocialProofWrapper: React.FC<SocialProofType> = ({
  cards,
  ctaCopy,
  ctaLink,
  ctaUrl,
  headline,
  hideCards,
  hideHeader,
  hideLogos,
  logos,
  logosHeadline,
  builderBlock,
}) => {
  const { onClick } = useOnClick();

  return (
    <SocialProof
      cards={cards}
      builderBlocksComponent={BuilderBlocks}
      builderBlock={builderBlock}
      ctaCopy={ctaCopy}
      ctaLink={ctaLink}
      headline={headline}
      hideCards={hideCards}
      hideHeader={hideHeader}
      hideLogos={hideLogos}
      logos={logos}
      logosHeadline={logosHeadline}
      onClick={onClick}
      ctaUrl={ctaUrl}
    />
  );
};

export default SocialProofWrapper;

export const RegisterButterFlyEffect = () => {
  Builder.registerComponent(SocialProofWrapper, {
    name: "butterfly-effect",
    inputs: [
      {
        name: "hideHeader",
        type: "boolean",
        defaultValue: false,
      },
      {
        name: "hideCards",
        type: "boolean",
        defaultValue: false,
      },
      {
        name: "hideLogos",
        type: "boolean",
        defaultValue: false,
      },
      {
        name: "headline",
        type: "richText",
      },
      {
        name: "ctaLink",
        type: "reference",
      },
      {
        name: "ctaCopy",
        type: "string",
      },
      {
        name: "ctaUrl",
        type: "string",
      },
      {
        name: "cards",
        type: "list",
        subFields: [
          {
            name: "disableTestimonial",
            type: "boolean",
            helperText:
              "Switching to ON turns off the testimonial and allows the editor to add elements visually into the card.",
          },
          {
            name: "cardTitle",
            type: "richText",
          },
          {
            name: "image",
            type: "file",
          },
          {
            name: "cardContent",
            type: "uiBlocks",
            defaultValue: [],
          },
          {
            name: "imageAltText",
            type: "string",
          },
          {
            name: "quote",
            type: "longText",
          },
          {
            name: "ctaCopy",
            type: "string",
          },
          {
            name: "ctaLink",
            type: "reference",
          },
          {
            name: "ctaUrl",
            type: "string",
          },
        ],
      },
      {
        name: "logosHeadline",
        type: "longText",
      },
      {
        name: "logos",
        type: "list",
        subFields: [
          {
            name: "image",
            type: "file",
          },
          {
            name: "imageAltText",
            type: "string",
          },
        ],
      },
    ],
  });
};
